import { FC } from 'react';
import { Button, Checkbox, Form, Modal } from 'antd';
import i from '../../../assets/i.svg';
import close from '../../../assets/RoundedClose.svg';
import WarningIcon from '../../../assets/WarningIcon.png';
import { tenderDataProps } from '../../../pages/TenderViewPage/types';
import { useSendTaskMutation } from '../../../api/tenders';
import './index.scss';
import { Loader } from '../../Loader/Loader';

interface ModalProps {
    openModal: boolean;
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
    tenderData?: tenderDataProps;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
    setConfirmModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const NextPhaseModal: FC<ModalProps> = ({
    openModal,
    setOpenModal,
    tenderData,
    setTrigger,
    setConfirmModal
}) => {
    const [sendTask, { isLoading }] = useSendTaskMutation();
    const [form] = Form.useForm();

    const participatingChecked = Form.useWatch('participating', form);
    const addedByBuyerChecked = Form.useWatch('addedByBuyer', form);

    const participating =
        tenderData?.invited_suppliers?.items?.filter((elem) => {
            if (elem.status === 'registered') {
                return elem;
            }
        }) ?? [];

    const addedByBuyer =
        tenderData?.invited_suppliers?.items?.filter((elem) => {
            if (elem.company.is_candidate && elem.status === 'invited') {
                return elem;
            }
        }) ?? [];

    const isProceedDisabled =
        (participating?.length < 10 && !participatingChecked) || (!!addedByBuyer?.length && !addedByBuyerChecked);

    const sendTaskFunc = async () => {
        let formData = {};

        formData = {
            id: tenderData?.id
        };
        try {
            setOpenModal(false);
            setConfirmModal(true);
        } catch {}
    };

    return (
        <>
            <Modal
                className="modal-modal"
                destroyOnClose
                centered
                open={openModal}
                onCancel={() => setOpenModal(false)}
                closeIcon={<img src={close} />}
                footer={false}
            >
                <div className="modal">
                    <div className="modal__header meeting" style={{ height: '88px' }}>
                        <div className="modal__title">Start Evaluate Phase</div>
                    </div>
                    <Form form={form} onFinish={sendTaskFunc}>
                        <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                            <div className="note">
                                <img src={i} />
                                <div>
                                    You are about to start the Evaluate Phase 1 with {participating?.length}{' '}
                                    participating suppliers. No additional suppliers can be added once you proceed.
                                </div>
                            </div>
                            <div className="nextPhaseModal">
                                {participating?.length < 10 && (
                                    <div className="nextPhaseModal__block">
                                        <div className="nextPhaseModal__title">
                                            <h1>
                                                <img src={WarningIcon} /> Limited supplier pool
                                            </h1>
                                            <h3>Fewer suppliers means fewer options for the customer.</h3>
                                        </div>
                                        <div className="nextPhaseModal__checkbox">
                                            <Form.Item name="participating" valuePropName="checked">
                                                <Checkbox>
                                                    I understand and wish to proceed with the current supplier count.
                                                </Checkbox>
                                            </Form.Item>
                                        </div>
                                    </div>
                                )}
                                {!!addedByBuyer?.length && (
                                    <div className="nextPhaseModal__block">
                                        <div className="nextPhaseModal__title">
                                            <h1>
                                                <img src={WarningIcon} /> “Added by Buyer” supplier is not participating
                                            </h1>
                                            <h3>
                                                One or more nominated suppliers are not participating in this
                                                opportunity.
                                            </h3>
                                        </div>
                                        <div className="nextPhaseModal__checkbox">
                                            <Form.Item name="addedByBuyer" valuePropName="checked">
                                                <Checkbox>
                                                    I confirm the customer has agreed to proceed without their nominated
                                                    supplier(s).
                                                </Checkbox>
                                            </Form.Item>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyItems: 'space-between',
                                gap: '16px',
                                width: '100%',
                                padding: '0 52px'
                            }}
                        >
                            <Button block key="back" onClick={() => setOpenModal(false)} className="cancel">
                                Cancel
                            </Button>
                            <Button block type="primary" htmlType="submit" disabled={isProceedDisabled}>
                                {isLoading ? <Loader /> : 'Proceed'}
                            </Button>
                        </div>{' '}
                    </Form>
                </div>
            </Modal>
        </>
    );
};
